module.exports = __webpack_public_path__ + "e7340b35eed04250fcc4b06fc0844e32.webp";